import type { DefaultToastOptions } from 'react-hot-toast'

export const TIME_ZONE = 'Asia/Bangkok'
export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const INPUT_VARIANT: 'bordered' | 'faded' | 'flat' | 'underlined' =
  'bordered'
export const DATA_EMPTY_TEXT = 'No data found.'

export const TOAST_OPTIONS: DefaultToastOptions = {
  duration: 2500,
  error: {
    iconTheme: {
      primary: '#000000',
      secondary: '#ffffff',
    },
  },
  style: {
    border: 'none',
    borderRadius: 'none',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    fontSize: '0.875rem',
  },
  success: {
    iconTheme: {
      primary: '#000000',
      secondary: '#ffffff',
    },
  },
}
